

export const setToken = (newToken) => {
  sessionStorage.setItem("token", newToken);
};

export const getToken = () => {
  return sessionStorage.getItem("token");
};

export const clearToken = () => {
  sessionStorage.removeItem("token");
};
